import {
  FillAto,
  FillCompromised,
  FillMail,
  FillPhishing,
  FillSafe,
  FillTeams,
  Spam,
} from 'components/lib/DesignSystem/Icons'

export const QUICK_FILTERS_CHANGE = 'ResolutionCenter/QuickFilters/QUICK_FILTERS_CHANGE'
export const QUICK_FILTERS_RESET = 'ResolutionCenter/QuickFilters/QUICK_FILTERS_RESET'

export const QUICK_FILTER = {
  PHISHING: 1,
  SPAM: 2,
  COMPROMISED: 3,
  SAFE: 4,
  MAIL: 5,
  ATO: 6,
  TEAMS: 7,
}

export const FILTER_TYPES = {
  CLASSIFICATION: 1,
  INCIDENT: 2,
}

export const QUICK_FILTER_OPTIONS = {
  PHISHING: {
    value: QUICK_FILTER.PHISHING,
    Icon: FillPhishing,
    type: FILTER_TYPES.CLASSIFICATION,
    title: 'Phishing',
  },
  SPAM: {
    value: QUICK_FILTER.SPAM,
    Icon: Spam,
    type: FILTER_TYPES.CLASSIFICATION,
    title: 'Spam',
  },
  COMPROMISED: {
    value: QUICK_FILTER.COMPROMISED,
    Icon: FillCompromised,
    type: FILTER_TYPES.CLASSIFICATION,
    title: 'Compromised',
  },
  SAFE: {
    value: QUICK_FILTER.SAFE,
    Icon: FillSafe,
    type: FILTER_TYPES.CLASSIFICATION,
    title: 'Safe',
  },
  MAIL: {
    value: QUICK_FILTER.MAIL,
    Icon: FillMail,
    type: FILTER_TYPES.INCIDENT,
    title: 'Mail',
  },
  ATO: {
    value: QUICK_FILTER.ATO,
    Icon: FillAto,
    type: FILTER_TYPES.INCIDENT,
    title: 'Account Takeover',
  },
  TEAMS: {
    value: QUICK_FILTER.TEAMS,
    Icon: FillTeams,
    type: FILTER_TYPES.INCIDENT,
    title: 'Teams',
  },
}

export const QUICK_FILTER_OPTIONS_ALL = Object.keys(QUICK_FILTER_OPTIONS).map(
  (key) => QUICK_FILTER_OPTIONS[key]
)

export const QUICK_FILTER_OPTIONS_BY_URL_STATE = {
  unclassified: [QUICK_FILTER_OPTIONS.MAIL, QUICK_FILTER_OPTIONS.ATO, QUICK_FILTER_OPTIONS.TEAMS],
  classified: QUICK_FILTER_OPTIONS_ALL,
  scanback: [
    QUICK_FILTER_OPTIONS.PHISHING,
    QUICK_FILTER_OPTIONS.SPAM,
    QUICK_FILTER_OPTIONS.SAFE,
    QUICK_FILTER_OPTIONS.MAIL,
  ],
}

export const includesATOFilter = (filter = []) => filter.includes(QUICK_FILTER.ATO)
export const includesCompromisedFilter = (filter = []) => filter.includes(QUICK_FILTER.COMPROMISED)
export const includesTeamsFilter = (filter = []) => filter.includes(QUICK_FILTER.TEAMS)

const QUICK_FILTER_VALUES = new Set(Object.values(QUICK_FILTER))

// A KPI deep link pins extra quick filters with ?quickFilters=3. It rides in the query
// string, not router state: the legacy consumers strip that state before the lazily
// loaded incidents page mounts, so the filter would be gone by the time we read it.
export const readQuickFiltersParam = (search) =>
  (new URLSearchParams(search).get('quickFilters') || '')
    .split(',')
    .map(Number)
    .filter((v) => QUICK_FILTER_VALUES.has(v))
